import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { HtmlTooltip, IconContainer, StyledLeftAlignedStack, StyledStack } from "../../../../components/commonComponents/StyledComponents/styled";
import { Box, Paper, Table, TableBody, TableContainer, TableHead, TableRow } from "@mui/material";
import { Archive, Delete, Edit, Unarchive } from "@mui/icons-material";
import NewWorkspaceSection from "./NewWorkspaceSection";
import { MediumWidthStyledTableCell, StyledTableCell } from "../../../../components/commonComponents/TabularLists/styles";
import { archiveWorkspaceSection, deleteWorkspaceSection, fetchWorkspaceSections, recoverWorkspaceSection } from "../../../../api_calls/WorkspaceSections";
import Confirmation from "../../../../components/commonComponents/ConfirmationBox/Confirmation";
import { toast } from "react-toastify";

const SectionsList = ({ listType, sectionType }) => {
    const currentStateData = useSelector((state) => state.userSelections);
    const dispatchAction = useDispatch();
    const [editSectionPopup, setEditSectionPopup] = React.useState(false);
    const [sectionDetailToEdit, setSectionDetailToEdit] = React.useState({});

    const [showConfirmation, setShowConfirmation] = React.useState(false);
    const [sectionIdToArchive, setSectionIdToArchive] = React.useState("");


    const [showDeleteConfirmation, setShowDeleteConfirmation] = React.useState(false);
    const [sectionIdToDelete, setSectionIdToDelete] = React.useState("");
    const archivedList = listType === "archived" ? true : false;

    const listItems = typeof currentStateData.workspace_report_sections !== "undefined" &&
        currentStateData.workspace_report_sections !== null &&
        currentStateData.workspace_report_sections.length > 0 ? currentStateData.workspace_report_sections.filter(sec => {
            return sec.archived === archivedList && sec.type === sectionType;
        }) : [];

    // React.useEffect(() => {
    //     fetchWorkspaceSections();
    // }, []);

    return (
        <>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 400 }} aria-label="customized table">
                    {/* ------ header row ------ */}
                    <TableHead>
                        <TableRow>
                            <MediumWidthStyledTableCell
                                sx={{ padding: "5px", paddingLeft: "20px", fontSize: "13px" }}
                                align="left"
                                className="text-wrapper"
                            >
                                Section Name (in CAP Explorer)
                            </MediumWidthStyledTableCell>
                            <MediumWidthStyledTableCell
                                sx={{ padding: "5px", fontSize: "13px", width: "180px" }}
                                align="left"
                            >
                                Embeddable ID
                            </MediumWidthStyledTableCell>
                            <MediumWidthStyledTableCell
                                sx={{ padding: "5px", fontSize: "13px" }}
                                align="left"
                                className="text-wrapper"
                            >
                                Filters
                            </MediumWidthStyledTableCell>
                            <MediumWidthStyledTableCell
                                sx={{ padding: "5px", fontSize: "13px", width: "140px" }}
                                align="left"
                            // className="text-wrapper"
                            >
                                Description
                            </MediumWidthStyledTableCell>
                            <MediumWidthStyledTableCell
                                sx={{ padding: "5px", fontSize: "13px" }}
                                align="left"
                                className="text-wrapper"
                            >

                                <StyledStack direction="row" spacing={1}>
                                    <div>Action</div>
                                </StyledStack>

                            </MediumWidthStyledTableCell>
                        </TableRow>
                    </TableHead>
                    {/* -------- table body ------- */}
                    <TableBody>
                        {/* ------------- loop through sections list ---------- */}
                        {listItems.length > 0 ? listItems.map(section => {
                            return (
                                <TableRow key={"section_id_" + section.id}>
                                    {/* ------ section name ------- */}
                                    <MediumWidthStyledTableCell
                                        sx={{ padding: "5px", paddingLeft: "20px", fontSize: "13px" }}
                                        component="td"
                                        scope="row"
                                        className="text-wrapper wrapLargeText"
                                    >
                                        {section.name}
                                    </MediumWidthStyledTableCell>
                                    {/* -------- embeddable id --------- */}
                                    <MediumWidthStyledTableCell
                                        sx={{ padding: "5px", fontSize: "13px", width: "180px" }}
                                        component="td"
                                        scope="row"
                                    >
                                        {section.id_embeddable}
                                    </MediumWidthStyledTableCell>
                                    {/* -------- filters ----------- */}
                                    <MediumWidthStyledTableCell
                                        sx={{ padding: "5px", fontSize: "13px" }}
                                        component="td"
                                        scope="row"
                                        className="text-wrapper"
                                    >
                                        {section.filters.length > 0 ?
                                            section.filters.map(filter => filter.keyword + " (" + filter.type.charAt(0).toUpperCase() + filter.type.slice(1) + ")").join(", ")
                                            :
                                            "No filters applied"}
                                    </MediumWidthStyledTableCell>
                                    {/* ------------- description ---------- */}
                                    <MediumWidthStyledTableCell
                                        sx={{ padding: "5px", fontSize: "13px", width: "140px" }}
                                        component="td"
                                        scope="row"
                                    // className="text-wrapper"
                                    >
                                        {section.description}
                                    </MediumWidthStyledTableCell>
                                    {/* ------------- actions ---------- */}
                                    <MediumWidthStyledTableCell
                                        sx={{ padding: "5px", fontSize: "13px" }}
                                        component="td"
                                        scope="row"
                                        className="text-wrapper"
                                    >
                                        <StyledStack direction="row" spacing={1}>
                                            {/* ------ actions for available list ------- */}
                                            {
                                                archivedList === false && (
                                                    <>
                                                        <HtmlTooltip title="Edit">
                                                            <IconContainer>
                                                                <a
                                                                    href="#editClip"
                                                                    aria-label={"edit workspace section for " + section.name}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        setEditSectionPopup(true);
                                                                        setSectionDetailToEdit(section);
                                                                    }}
                                                                >
                                                                    <Edit fontSize="small" sx={{ color: "#AF3241", marginTop: "6px" }} />
                                                                </a>
                                                            </IconContainer>
                                                        </HtmlTooltip>
                                                        {/* ------ archive ------ */}
                                                        {
                                                            sectionType !== "impression" && (
                                                                <HtmlTooltip title="Archive">
                                                                    <IconContainer>
                                                                        <a
                                                                            href="#editClip"
                                                                            aria-label={"archive workspace section for " + section.name}
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                setSectionIdToArchive(section.id);
                                                                                setShowConfirmation(true);
                                                                            }}
                                                                        >
                                                                            <Archive fontSize="small" sx={{ color: "#AF3241", marginTop: "6px" }} />
                                                                        </a>
                                                                    </IconContainer>
                                                                </HtmlTooltip>
                                                            )
                                                        }

                                                    </>
                                                )
                                            }
                                            {/* ------ actions for archived list ------ */}
                                            {
                                                archivedList === true && (
                                                    <>
                                                        <HtmlTooltip title="Recover">
                                                            <IconContainer>
                                                                <a
                                                                    href="#recoverSection"
                                                                    aria-label={"recover workspace section for " + section.name}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        recoverWorkspaceSection(section.id).then((res) => {
                                                                            if (res.success === false) {
                                                                                toast("Sorry, something went wrong.", { type: "error" });
                                                                            }
                                                                        });
                                                                    }}
                                                                >
                                                                    <Unarchive fontSize="small" sx={{ color: "#AF3241", marginTop: "6px" }} />
                                                                </a>
                                                            </IconContainer>
                                                        </HtmlTooltip>
                                                        {/* ------ delete ------ */}
                                                        <HtmlTooltip title="Delete">
                                                            <IconContainer>
                                                                <a
                                                                    href="#deleteSection"
                                                                    aria-label={"Delete workspace section for " + section.name}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        setSectionIdToDelete(section.id);
                                                                        setShowDeleteConfirmation(true);
                                                                    }}
                                                                >
                                                                    <Delete fontSize="small" sx={{ color: "#AF3241", marginTop: "6px" }} />
                                                                </a>
                                                            </IconContainer>
                                                        </HtmlTooltip>
                                                    </>
                                                )
                                            }

                                        </StyledStack>
                                    </MediumWidthStyledTableCell>
                                </TableRow>
                            )
                        }) : (
                            <TableRow>
                                <MediumWidthStyledTableCell
                                    sx={{ padding: "5px", paddingLeft: "20px", fontSize: "13px" }}
                                    component="td"
                                    scope="row"
                                    className="text-wrapper wrapLargeText"
                                    colSpan={5}
                                >
                                    No {archivedList === true ? "archived" : "available"} sections found.
                                </MediumWidthStyledTableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            {/* ------- confirmation popup (on click of archive button) -------- */}
            {showConfirmation && (
                <Confirmation
                    showConfirmationPopup={showConfirmation}
                    closePopup={(e) => {
                        setSectionIdToArchive("");
                        setShowConfirmation(false);
                    }}
                    confirmationActionCall={() => {
                        archiveWorkspaceSection(sectionIdToArchive).then((res) => {
                            if (res.success === true) {
                                setSectionIdToArchive("");
                                setShowConfirmation(false);
                            } else {
                                toast("Sorry, something went wrong.", { type: "error" });
                            }
                        });
                    }}
                    confirmationMessage={
                        <>
                            You are archiving a dashboard section. You can recover archived sections any time. <Box height={10} /> Do you want to proceed?
                        </>
                    }
                />
            )}




            {/* --------------- delete confirmation --------------- */}
            {showDeleteConfirmation && (
                <Confirmation
                    showConfirmationPopup={showDeleteConfirmation}
                    closePopup={(e) => {
                        setSectionIdToDelete("");
                        setShowDeleteConfirmation(false);
                    }}
                    confirmationActionCall={() => {
                        deleteWorkspaceSection(sectionIdToDelete).then((res) => {
                            if (res.success === true) {
                                setSectionIdToDelete("");
                                setShowDeleteConfirmation(false);
                            } else {
                                toast("Sorry, something went wrong.", { type: "error" });
                            }
                        });
                    }}
                    confirmationMessage={
                        <>
                            You are deleting an archived dashboard section. If the section is included in any published report, it will be removed from the report. This action cannot be undone. <Box height={10} /> Do you want to proceed?
                        </>
                    }
                />
            )}
            {/* --------- new section popup ----------- */}
            {
                editSectionPopup === true && (
                    <NewWorkspaceSection
                        showModal={editSectionPopup}
                        sectionDetails={sectionDetailToEdit}
                        sectionType={sectionType}
                        usedFor="edit"
                        closeModal={() => {
                            setEditSectionPopup(false);
                        }}
                    />
                )
            }

        </>
    );
};

export default SectionsList;
